import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Scrollbars } from "react-custom-scrollbars";

import "./ResourcesListing.scss";
import { getResourceDetails, resetField } from "../../../store/actions";
import SearchResources from "./searchResources";

const ResourcesListing = ({
	resourceDetails,
	getResourceDetails,
	resetField,
	selected,
	history,
	match
}) => {
	useEffect(() => {
		return () => {
			resetField("Resources.resourcesResult", {});
		};
	}, [resetField]);

	useEffect(() => {
		selected && getResourceDetails(selected.id);
	}, [getResourceDetails, selected]);

	const renderResourceDetails = () => {
		if (resourceDetails && resourceDetails.id) {
			setTimeout(() => {
				scrollbar && scrollbar.scrollToTop();
			}, 100);
			const { author, body, created, description, title } = resourceDetails;
			const d = new Date(created);
			return (
				<div className="col-9">
					<Scrollbars ref={(elem) => setScrollbar(elem)} autoHide>
						<div className="card card-primary p-4 w-100 m-0">
							<h3 className="text-primary-dark">{title}</h3>
							<div className="mb-3">
								{author ? <span className="text-secondary mr-4">Author: {author}</span> : null}
								{created ? (
									<span className="text-secondary mr-4">
										Created: {`${d.getMonth()}-${d.getDate()}-${d.getFullYear()}`}
									</span>
								) : null}
							</div>
							<div className="resource-image" dangerouslySetInnerHTML={{ __html: body }} />
							<div className="resource-description" dangerouslySetInnerHTML={{ __html: description }} />
						</div>
					</Scrollbars>
				</div>
			);
		}
		return null;
	};

	const [scrollbar, setScrollbar] = useState(null);

	return (
		<section className="page page-resources d-flex flex-column">
			<div className="container h-100 flex-fill d-flex flex-column">
				<h3>Resources</h3>
				<div className="row card-wrap flex-fill">
					<div className="col-3">
						<SearchResources
							history={history}
							match={match}
						/>
					</div>
					{renderResourceDetails()}
				</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Resources } = state;
	return {
		resourceList: get(Resources, "resourcesResult.results", []),
		resourceDetails: get(Resources, "resourceDetails", {}),
		selected: get(Resources, "selectedResource", null)
	};
};

const mapDispatchToProps = {
	getResourceDetails,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ResourcesListing);
